import React, { useState, createContext } from 'react';

export const ActivityContext = createContext();

export const ActivityProvider = ({ children }) => {
    const [isActive, setIsActive] = useState({
        'btn-1': 1,
        'btn-2': 0,
        'btn-3': 0
    })

    return (
        <ActivityContext.Provider value={[isActive, setIsActive]}>
            {children}
        </ActivityContext.Provider>
    )
}